import { Checkbox } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCartFunctions } from "../services/ApiServices/CartProductService";
import "../styles/sortbybar.css";
import { QuantityButton } from "./QuantityButton";

type CartProductRowProps = {
    product: any,
    setTotalPrice: (totalPrice: number) => void,
    fetchCartProduct: () => void,
    setProducts: (products: any) => void,
    totalPrice: number,
    products: any,
    setSelectedProducts: (products: any) => void,
    selectedProducts: any
    DeleteCartProduct: (id: string) => Promise<void>
    UpdateProductQuantity: (updateQuantity: any) => Promise<void>
}
 
export function CartProductRow({ product, DeleteCartProduct, UpdateProductQuantity, totalPrice, selectedProducts, setSelectedProducts, setTotalPrice, fetchCartProduct, products, setProducts }: CartProductRowProps) {

    const [totalProductPrice, setTotalProductPrice] = useState(product.totalPrice);
    const [isSelected, setIsSelected] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const selectProductHandle = (e : any) => {
      const isSelected = e.target.checked;
      setIsSelected(isSelected);
      if(isSelected){
          setTotalPrice(totalPrice + totalProductPrice);
          setSelectedProducts([...selectedProducts, product]);
      }
      else{
          setTotalPrice(totalPrice - totalProductPrice);
          setSelectedProducts(selectedProducts.filter((selectedProduct: any) => selectedProduct.id !== product.id));
      }  
      //console.log(selectedProducts);
    }

    const setTotalProductPriceHandle = (total: number) => {
      if(isSelected){
          setTotalPrice(totalPrice + total);
      }
      else{
          setTotalPrice(totalPrice - totalProductPrice);
      }    
    }

    const removeCartProduct = async (id: string) => {
        //remove product quicker
        setProducts(products.filter((product: any) => product.id !== id));
        //subtract if product is selected
        if(isSelected){
            setTotalPrice(totalPrice - totalProductPrice);
        }
        try{
            await DeleteCartProduct(id);
            //reload cart
            //fetchCartProduct();
        }
        catch (error: any) {
          if (error.response && error.response.data && error.response.data.message) {
            setErrorMessage(error.response.data.message);
          } else {
            setErrorMessage('An error occurred. Please try again later.');
          }
          return;
        }
    }

  return (
          <div className="flex gap-5 border-b-2 border-b-gray-500 pb-4 mb-3">
              <div className="flex gap-2">
                <Checkbox color="orange" crossOrigin={""} onChange={(e) => selectProductHandle(e) }/>
                <img src={!product.productSize ? 
                "https://swdstore.blob.core.windows.net/exe101/aobongchay.jpg" : 
                (product.productSize.product.productImages.length > 0 ? 
                product.productSize.product.productImages[0].imageUrl : 
                "https://swdstore.blob.core.windows.net/exe101/aobongchay.jpg")}
                alt="" className="w-16 h-16"/>
                <div className={"hidden"}>{totalProductPrice}</div>
              </div>
              <div className="flex-grow">
                  <div className="flex justify-between">
                    <h5>{product.productSize && product.productSize.name}</h5>
                    <button onClick={() => removeCartProduct(product.id)} className="text-3xl h-fit text-end">&times;</button>
                  </div>
                  <QuantityButton UpdateProductQuantity={UpdateProductQuantity} selected={isSelected} calculateTotalPrice={setTotalProductPriceHandle} setProductTotalPrice={setTotalProductPrice} cartProductId={product.id} quan={product.quantity} totalPrice={product.totalPrice} 
                  price={product.productSize ? product.productSize.product.price : 0}/>
              </div>
            </div>
     );
}
